import makeBookingsServiceRequest from '../utils/makeBookingServiceRequest';
import { API_ACTIONS, BOOKING_C2_ENDPOINT_PREFIX } from '../constants/endpoints';
import type { GetBusinessLogoRequest, GetBusinessLogoResponse } from './schema/getBusinessLogo';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';

export const getBusinessLogo = async (
    request: GetBusinessLogoRequest,
    beServer?: string
): Promise<GetBusinessLogoResponse | null> => {
    const perfDatapoint = new PerformanceDatapoint('getBusinessLogo');

    //Adding BE server to the request headers
    const requestHeaders = new Headers();
    requestHeaders.append('BEServerFqdn', beServer ?? '');

    try {
        const { smtpAddress, isAuthRequired } = request;
        const res = await makeBookingsServiceRequest({
            endpointPrefix: BOOKING_C2_ENDPOINT_PREFIX,
            smtpAddress,
            action: API_ACTIONS.GET_BUSINESS_LOGO,
            isAuthRequired,
            requestHeaders,
        });
        const response = await res.json();
        if (response?.image) {
            perfDatapoint.end();
            return response;
        } else {
            perfDatapoint.endWithError(DatapointStatus.ServerError);
            return null;
        }
    } catch (error) {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return null;
    }
};

export default getBusinessLogo;
